'use client';

import { c as _c } from "react/compiler-runtime";
import { ResponsiveSheet, ResponsiveSheetContent, ResponsiveSheetHeader, type ResponsiveSheetPresentation, ResponsiveSheetTitle } from '@repo/ui/components';
import { File } from '@repo/ui/icons';
import { useCreateCompanySheet } from './context';
import { CreateCompanyForm } from './form';
type CreateCompanySheetProps = {
  presentation?: ResponsiveSheetPresentation;
};
export const CreateCompanySheet = t0 => {
  const $ = _c(10);
  const {
    presentation: t1
  } = t0;
  const presentation = t1 === undefined ? "default" : t1;
  const {
    closeCreateCompanySheet,
    formKey,
    isOpen,
    options
  } = useCreateCompanySheet();
  if ((options?.presentation ?? "default") !== presentation) {
    return null;
  }
  let t2;
  if ($[0] !== closeCreateCompanySheet) {
    t2 = open => !open && closeCreateCompanySheet();
    $[0] = closeCreateCompanySheet;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ResponsiveSheetHeader className="p-0" data-sentry-element="ResponsiveSheetHeader" data-sentry-source-file="sheet.tsx"><ResponsiveSheetTitle className="flex items-center gap-3 text-3xl font-bold" data-sentry-element="ResponsiveSheetTitle" data-sentry-source-file="sheet.tsx"><File data-sentry-element="File" data-sentry-source-file="sheet.tsx" /> New company</ResponsiveSheetTitle></ResponsiveSheetHeader>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== formKey) {
    t4 = <ResponsiveSheetContent className="gap-8 overflow-y-auto p-6 max-lg:w-full! sm:max-w-sm" data-sentry-element="ResponsiveSheetContent" data-sentry-source-file="sheet.tsx">{t3}<CreateCompanyForm key={formKey} data-sentry-element="CreateCompanyForm" data-sentry-source-file="sheet.tsx" /></ResponsiveSheetContent>;
    $[3] = formKey;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isOpen || $[6] !== presentation || $[7] !== t2 || $[8] !== t4) {
    t5 = <ResponsiveSheet onOpenChange={t2} open={isOpen} presentation={presentation} data-sentry-element="ResponsiveSheet" data-sentry-component="CreateCompanySheet" data-sentry-source-file="sheet.tsx">{t4}</ResponsiveSheet>;
    $[5] = isOpen;
    $[6] = presentation;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const CreateCompanySheetNestedDialogOutlet = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CreateCompanySheet presentation="nested-dialog" data-sentry-element="CreateCompanySheet" data-sentry-component="CreateCompanySheetNestedDialogOutlet" data-sentry-source-file="sheet.tsx" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};